import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';

export var DataTools = {
	
	referenceData(options) {
		
		var refRefenceWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Re-Reference Records',
			icon: 'vaadin:arrow-right',				
			width: 700,
			height: 250,
			listeners: {
				ready: function() {						
					refRefenceWin.show();	
					
					var loadReferenceNo = function (refType, lookupValue, cbToPopulate, callback) {
						var paging = {
							max: 100
						};
						if (lookupValue) {
							paging.filterField = 'description';
							paging.filterValue = lookupValue;
						}
						UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
							
							var availableUnits = [];
							units.data.forEach(function(item) {
								if (item.code !== options.originalUnitId) {
									availableUnits.push(item);
								}
							});
							
							cbToPopulate.items = availableUnits;
							if (callback) {
								callback(cbToPopulate);
							}
						});

					};

					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [							
							{
								tag: 'vaadin-form-layout',										
								children: [
									{
										tag: 'vaadin-combo-box',
										itemid: 'referenceTypeCB',
										label: 'Reference Type',
										name: 'referenceType',
										'item-value-path': 'code',
										'item-label-path': 'description',										
										value: 'TRACTOR',
										postinit: function (combo) {
											Service.getLookupService().getLookupValues('ReferenceType').then(function (data) {
												var equipmentRefs = [];
												data.forEach(function(item){
													if (item.equipmentReference) {
														equipmentRefs.push(item);
													}
												});												
												combo.items = equipmentRefs;
												combo.required = true;
											});
											if (options.referenceTypeFixed) {
												combo.readonly = true;
											}
										},
										listeners: {
											change: function(e) {
												var typeCB = e.target;
												var newValue = typeCB.value;

												var refNoCB = ElementUtil.query(formPanel, 'destinationUnitId');
												refNoCB.value = '';
												var initRefNo = null;
												if (e.detail) {
													initRefNo = e.detail;
												}
												loadReferenceNo(newValue, initRefNo, refNoCB);																																								
											}
										}
									},
									{
										tag: 'vaadin-combo-box',
										itemid: 'destinationUnitId',
										label: 'Destination Unit',
										name: 'destinationUnitId',
										'item-value-path': 'code',
										'item-label-path': 'description',
										required: true,											
										postinit: function (combo) {
											setTimeout(function(){
												var refTypeCB = ElementUtil.query(formPanel, 'referenceTypeCB');
												var refNoCB = ElementUtil.query(formPanel, 'destinationUnitId');
												loadReferenceNo(refTypeCB.value, null, refNoCB);	
											}, 100);											
										},
										listeners: {
											input: {
												fn: function () {
													var refTypeCB = ElementUtil.query(formPanel, 'referenceTypeCB');
													var refNoCB = ElementUtil.query(formPanel, 'destinationUnitId');
													var inputElem = ElementUtil.findInputForCombo(refNoCB);

													loadReferenceNo(refTypeCB.value, inputElem.value, refNoCB);															
												},
												buffer: 500
											}
										}
									},																			
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:arrow-right', ' Transfer')
												],
												listeners: {
													click: function() {															

														if (formPanel.isValid()) {
															var data = formPanel.getData();
															
															options.proceed(data, function (result) {
																//success
																window.DL.MessageUtil.showToast('Success', 'Transferred records', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																refRefenceWin.close();
															}, function (results) {
																//fail
																var errors = [];
																for (var key in results.errors) {
																	errors.push(key + " - " + results.errors[key]);
																}
																window.DL.MessageUtil.showToastError('Failed to Transfer Records.<br>' + errors);
															});
														}	
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function() {														
														if (options.cancelCallback) {
															options.cancelCallback();
														}
														refRefenceWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});			

					refRefenceWin.addToContentElement(formPanel);
					
				}
			}
		});		
		
	},
	
	timeShiftData(options) {
		var timeShiftWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Time Shift Records',
			icon: 'vaadin:clock',				
			width: 700,
			height: 400,
			listeners: {
				ready: function() {						
					timeShiftWin.show();
					
					
					if (options.bulk) {
						
					}
					
					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [							
							{
								tag: 'vaadin-form-layout',										
								children: [									
									{
										tag: 'dl-unitselection',
										itemId: 'unitSelection',
										'class': (options.bulk ? '' : 'hide'),
										properties: {
											showReportOptions: false
										},
										colspan: 2
									},									
									{
										tag: 'vaadin-date-time-picker',
										label: 'Start Date(mm/dd/yyyy hh:mm:ss)',
										name: 'dataStartDts',
										'class': (options.bulk ? '' : 'hide'),
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
										required: true
									},
									{
										tag: 'vaadin-date-time-picker',
										label: 'End Date(mm/dd/yyyy hh:mm:ss)',
										name: 'dataEndDts',
										'class': (options.bulk ? '' : 'hide'),
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
										required: true
									},
									{
										tag: 'vaadin-number-field',										
										name: 'shiftAmountHours',
										label: 'Hours to Shift',																				
										required: true,										
										min: -(24*90),
										max: (24*90)
									},
									{
										tag: 'vaadin-combo-box',
										itemid: 'overlapHandlingCB',
										label: 'OverLap Handling',
										name: 'overlapHandling',
										'item-value-path': 'code',
										'item-label-path': 'description',										
										value: 'FAIL',
										postinit: function (combo) {
											Service.getLookupService().getLookupValues('TimeShiftHandlingType').then(function (data) {																							
												combo.items = data;
												combo.required = true;
											});											
										}
									},																											
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:arrow-right', ' Shift')
												],
												listeners: {
													click: function() {															

														if (formPanel.isValid()) {
															var data = formPanel.getData();
															data.unitSelection = ElementUtil.query(formPanel, 'unitSelection').unitSelectionValue();
															
															var loadMask = formPanel.showLoading('Submitting shift task');
															options.proceed(data, function (result) {
																loadMask.remove();
																
																window.DL.MessageUtil.showToast('Success', 'Add task to time shift Records', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																timeShiftWin.close();
															}, function (results) {
																loadMask.remove();
																
																//fail
																var errors = [];
																for (var key in results.errors) {
																	errors.push(key + " - " + results.errors[key]);
																}
																window.DL.MessageUtil.showToastError('Failed to Shift Records.<br>' + errors);
															});
														}	
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function() {														
														if (options.cancelCallback) {
															options.cancelCallback();
														}
														timeShiftWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});			

					timeShiftWin.addToContentElement(formPanel);					
					
				}
			}
		});
	},
		
	recalculate(options) {
		var recalculateWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Recalculate',
			icon: 'vaadin:rotate-right',				
			width: 700,
			height: 400,
			listeners: {
				ready: function() {						
					recalculateWin.show();
					
					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [							
							{
								tag: 'vaadin-form-layout',										
								children: [									
									{
										tag: 'dl-unitselection',
										itemId: 'unitSelection',
										'class': (options.bulk ? '' : 'hide'),
										properties: {
											showReportOptions: false
										},
										colspan: 2
									},									
									{
										tag: 'vaadin-date-time-picker',
										label: 'Date(mm/dd/yyyy hh:mm:ss)',
										name: 'startDts',
										'class': (options.bulk ? '' : 'hide'),
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
										required: true
									},
									{
										tag: 'vaadin-date-time-picker',
										label: 'Date(mm/dd/yyyy hh:mm:ss)',
										name: 'endDts',
										'class': (options.bulk ? '' : 'hide'),
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T23:59:59',
										required: true
									},									
									{
										tag: 'vaadin-combo-box',
										itemid: 'calcStageCB',
										label: 'Calculation Stage',
										name: 'calculationStage',
										'item-value-path': 'code',
										'item-label-path': 'description',										
										value: 'ROUTING',
										postinit: function (combo) {
											Service.getLookupService().getLookupValues('CalculationStage').then(function (data) {																							
												combo.items = data;
												combo.required = true;
											});											
										}
									},																											
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:rotate-right', ' Re-Calculate')
												],
												listeners: {
													click: function() {															

														if (formPanel.isValid()) {
															var data = formPanel.getData();
															data.unitSelection = ElementUtil.query(formPanel, 'unitSelection').unitSelectionValue();
															
															options.proceed(data, function (result) {
																//success
																window.DL.MessageUtil.showToast('Success', 'Scheduled Re-calculate', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																recalculateWin.close();
															}, function (results) {
																//fail
																var errors = [];
																for (var key in results.errors) {
																	errors.push(key + " - " + results.errors[key]);
																}
																window.DL.MessageUtil.showToastError('Failed to Schedule Re-calc.<br>' + errors);
															});
														}	
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function() {														
														if (options.cancelCallback) {
															options.cancelCallback();
														}
														recalculateWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});			

					recalculateWin.addToContentElement(formPanel);
				}
			}
		});		
	},
	
	deleteData(options) {
		var deleteWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Delete Data',
			icon: 'vaadin:trash',				
			width: 700,
			height: 400,
			listeners: {
				ready: function() {						
					deleteWin.show();
					
					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [							
							{
								tag: 'vaadin-form-layout',										
								children: [									
									{
										tag: 'dl-unitselection',
										itemId: 'unitSelection',
										'class': (options.bulk ? '' : 'hide'),
										properties: {
											showReportOptions: false
										},
										colspan: 2
									},									
									{
										tag: 'vaadin-date-time-picker',
										label: 'Date(mm/dd/yyyy hh:mm:ss)',
										name: 'startDts',
										'class': (options.bulk ? '' : 'hide'),
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
										required: true
									},
									{
										tag: 'vaadin-date-time-picker',
										label: 'Date(mm/dd/yyyy hh:mm:ss)',
										name: 'endDts',
										'class': (options.bulk ? '' : 'hide'),
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
										required: true
									},									
									{
										tag: 'vaadin-combo-box',
										itemid: 'requestDateTypeCB',
										label: 'Request Date Type',
										name: 'requestDateType',
										'item-value-path': 'code',
										'item-label-path': 'description',										
										value: 'DATA_DTS',
										postinit: function (combo) {
											Service.getLookupService().getLookupValues('DataDeleteMode').then(function (data) {																							
												combo.items = data;
												combo.required = true;
											});												
										}
									},
									{
										tag: 'vaadin-checkbox',									
										name: 'countOnly',
										label: 'Count Only'										
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary error',
												children: [
													ElementUtil.makeIcon('vaadin:trash', ' Delete')
												],
												listeners: {
													click: function() {															

														if (formPanel.isValid()) {
															var data = formPanel.getData();															
															data.unitSelection = ElementUtil.query(formPanel, 'unitSelection').unitSelectionValue();
															
															options.proceed(data, function (result) {
																
																//success
																window.DL.MessageUtil.showToast('Success', 'Scheduled Delete Task (if set to count; see task for details)', {
																	theme: 'success',
																	position: 'top-stretch'
																});
																deleteWin.close();
															}, function (results) {
																//fail
																var errors = [];
																for (var key in results.errors) {
																	errors.push(key + " - " + results.errors[key]);
																}
																window.DL.MessageUtil.showToastError('Failed to Schedule delete.<br>' + errors);
															});
														}	
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function() {														
														if (options.cancelCallback) {
															options.cancelCallback();
														}
														deleteWin.close();
													}
												}
											}
										]
									}
								]
							}
						]
					});			

					deleteWin.addToContentElement(formPanel);					
					
				}
			}
		});	
	}
	
};

